var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConversation = function SvgIconConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.213,
    r: 3.5,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M21 15.546a8.8 8.8 0 0 0 1.032-4.15c0-1.38-.316-2.686-.88-3.85M3.032 15.546A8.805 8.805 0 0 1 2 11.396c0-1.38.317-2.686.88-3.85M18 14.546a6.604 6.604 0 0 0 .774-3.112 6.6 6.6 0 0 0-.66-2.888M6.032 14.546a6.604 6.604 0 0 1-.774-3.112c0-1.035.237-2.015.66-2.888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M16.824 22.213c.92 0 1.67-.67 1.676-1.49v-.6c0-1.882-1.733-3.41-3.868-3.41H9.368c-2.134 0-3.868 1.528-3.868 3.41v.594c0 .826.75 1.496 1.676 1.496z"
  })));
};
export default SvgIconConversation;